package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions

@Serializable
data class ParentNoteCreateRequest(
    @SerialName("school_id") val schoolId: String,
    @SerialName("student_id") val studentId: String,
    @SerialName("parent_id") val parentId: String,
    val title: String? = null,
    val message: String,
    val status: String = SystemLookupOptions.codes("PARENT_NOTE_STATUS").firstOrNull().orEmpty(),
    @SerialName("is_active") val isActive: Boolean = true,
    val id: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList()
)

@Serializable
data class ParentNoteUpdateRequest(
    val title: String? = null,
    val message: String? = null,
    val status: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList()
)
